import Image1 from "../../Assets/images/gallery1.jpg";
import Image2 from "../../Assets/images/gallery2.jpg";
import Image3 from "../../Assets/images/gallery3.jpg";
import Image4 from "../../Assets/images/gallery4.jpg";
import Image5 from "../../Assets/images/gallery5.jpg";
import Image6 from "../../Assets/images/gallery6.jpg";
import Image7 from "../../Assets/images/gallery7.jpg";
import Image8 from "../../Assets/images/gallery8.jpg";
import Image9 from "../../Assets/images/gallery9.jpg";
import Image10 from "../../Assets/images/gallery10.jpg";
import Image11 from "../../Assets/images/gallery11.jpg";
import Image12 from "../../Assets/images/gallery12.jpg";
import Image13 from "../../Assets/images/gallery13.jpg";
import Image14 from "../../Assets/images/gallery14.jpg";
import Image15 from "../../Assets/images/gallery15.jpg";
import Image17 from "../../Assets/images/gallery17.jpg";
import Image18 from "../../Assets/images/gallery18.jpg";
import Image19 from "../../Assets/images/gallery19.jpg";
import Image20 from "../../Assets/images/gallery20.jpg";
import Image21 from "../../Assets/images/gallery21.jpg";
import Image22 from "../../Assets/images/gallery22.jpg";
import Image23 from "../../Assets/images/gallery23.jpg";
import Image24 from "../../Assets/images/gallery24.jpg";
import Image25 from "../../Assets/images/gallery25.jpg";

export const galleryImages = [
  {
    id: 24,
    src: Image24,
  },
  {
    id: 25,
    src: Image25,
  },
  {
    id: 3,
    src: Image3,
  },
  {
    id: 4,
    src: Image4,
  },
  {
    id: 5,
    src: Image5,
  },
  {
    id: 6,
    src: Image6,
  },
  {
    id: 7,
    src: Image7,
  },
  {
    id: 8,
    src: Image8,
  },
  {
    id: 9,
    src: Image9,
  },
  {
    id: 10,
    src: Image10,
  },
  {
    id: 11,
    src: Image11,
  },
  {
    id: 12,
    src: Image12,
  },
  {
    id: 13,
    src: Image13,
  },
  {
    id: 14,
    src: Image14,
  },
  {
    id: 15,
    src: Image15,
  },
  {
    id: 17,
    src: Image17,
  },
  {
    id: 18,
    src: Image18,
  },
  {
    id: 19,
    src: Image19,
  },
  {
    id: 20,
    src: Image20,
  },
  {
    id: 21,
    src: Image21,
  },
  {
    id: 22,
    src: Image22,
  },
  {
    id: 23,
    src: Image23,
  },
  {
    id: 1,
    src: Image1,
  },
  {
    id: 2,
    src: Image2,
  },
];

export default galleryImages;
